const formatScheduleTime = (value) => {
  const match = String(value || "").match(/^(\d{1,2}):(\d{2})/);
  return match ? `${match[1].padStart(2, "0")}:${match[2]}` : "";
};

export const buildScheduleSmsMessage = (row, { includeTripType = false } = {}) => [
  `날짜: ${row.date || ""}`,
  `시간: ${formatScheduleTime(row.time)}`,
  includeTripType && row.one_round ? row.one_round : null,
  `출발지: ${row.start || ""}`,
  row.transit ? `경유지: ${row.transit}` : null,
  `도착지: ${row.destination || ""}`,
].filter(Boolean).join("\n\n");

export const buildUserSmsMessage = (row, extraMessage = "") => [
  buildScheduleSmsMessage(row),
  row.car_number ? `차량번호: ${row.car_number}` : null,
  row.human_name ? `기사명: ${row.human_name}` : null,
  row.phone ? `핸드폰: ${row.phone}` : null,
  String(extraMessage || "").trim() ? `기타: ${String(extraMessage).trim()}` : null,
].filter(Boolean).join("\n\n");
